import React from 'react';
import LandCoverMonitorMap from './LandCoverMonitorMap';
import PropTypes from 'prop-types';

const MonitorComparisonMap = ({
  landCoverData,
  coordinates,
  keyId,
  info,
  legendData,
  variant,
  label
}) => {
  // const enhancedLandCoverData = landCoverData?.map((item, index) => {
  //   const key = `${keyId}_${index}`;
  //   return { ...item, key };
  // });

  return (
    landCoverData && (
      <LandCoverMonitorMap
        landCoverData={landCoverData}
        coordinates={coordinates}
        info={info}
        legendData={legendData}
        variant={variant}
        label={label}
      />
    )
  );
};

MonitorComparisonMap.propTypes = {
  landCoverData: PropTypes.array, // Validate landCoverData as an array
  coordinates: PropTypes.array, // Validate coordinates as an array
  keyId: PropTypes.string,
  info: PropTypes.object,
  legendData: PropTypes.any,
  variant: PropTypes.any,
  label: PropTypes.any
};

export default MonitorComparisonMap;
